<!-- <nb-card status="success">
    <nb-card-header >
      <div style="text-align: center;">
        Verification Application
      </div>
    </nb-card-header> 
    <nb-card-body>
      <div class="row" style="justify-content: center;padding-top: 15px; height: 110px;">
          <button nbButton  style="height: 50px;width: 130px;background-image: linear-gradient(#40dc7e, #8A7FFF);background-repeat: repeat-x" (click)="dashboardRoutes()">
              <h4 > <b> Go </b> </h4>
          </button>
      </div>
    </nb-card-body>
</nb-card> -->
<!-- <marquee><u><b style="color:red; width: 90vw; font-size: 24px;">Payment gateway is under maintenance. Request you to check after sometime.</b></u></marquee> -->

<div class="row">
	<div class="col-xxxl-12 col-xxl-12 col-lg-12 col-md-12">
      	<nb-card ascent="success">
        	<nb-card-header ><h4> Welcome to Verification of documents! </h4></nb-card-header> 
        	<nb-card-header ><h4> कागदपत्रांच्या पडताळणीमध्ये आपले स्वागत आहे! </h4></nb-card-header> 

        	<nb-card-body>
				<div class="row">
					<div class="col-md-9">
						<p style="margin: 10px; justify-content : center;">
							नमस्कार !! 
							<br> एकल अर्ज वापरून पडताळणी (Verification) साठी अर्ज करण्यासाठी हा डॅशबोर्ड आहे. तुमच्या उजवीकडील मेनू तुम्हाला या सिंगल विंडो ऍप्लिकेशन प्रक्रियेचा अखंडपणे वापर करण्यास मदत करेल.
						</p>
						
						<h6 style="color: red;">
							*कृपया लक्षात घ्या की पुण्यश्लोक अहिल्यादेवी होळकर सोलापूर विद्यापीठ केवळ पुण्यश्लोक अहिल्यादेवी होळकर सोलापूर विद्यापीठाशी संलग्न (Affiliated) असलेल्या महाविद्यालयांतील कागदपत्रांची साक्ष/पडताळणी (Attest/Verify) करू शकते.
						  </h6>						
					</div>
					<div class="col-md-3">
            <nb-card status="success">
              <nb-card-header >
                <div style="text-align: center;">
                  Verification Application
                </div>
              </nb-card-header> 
              <nb-card-body>
                <div class="row" style="justify-content: center;padding-top: 15px; height: 110px;">
                    <button nbButton  style="height: 50px;width: 130px;background-image: linear-gradient(#40dc7e, #8A7FFF);background-repeat: repeat-x" (click)="dashboardRoutes()">
                        <h4 > <b> Go </b> </h4>
                    </button>
                </div>
              </nb-card-body>
          </nb-card>
					</div>
				</div>
        	</nb-card-body>
      	</nb-card>
    </div>
	<br/>

    <!-- <div class="col-xxxl-8 col-xxl-8 col-lg-7 col-md-8">
      	<nb-card status="success" size="xsmall" style="height: 90%;">
        	<nb-card-header><h4>Process</h4></nb-card-header>
        	<nb-card-body>
				<div class="row">
				
					<div class="col-xl-3" style="padding-top : 50px;">
						<p>Verification Manual</p>
						<a href="{{serverUrl}}/images/SU-VerificationManualStudent.pdf" target="_blank">
							<img src="{{pdfImg}}" width="150px;" height="100px;">
						</a>
					</div>
				</div>
            	
			</nb-card-body>
        </nb-card>
    </div> -->
	<div class="col-xl-4">
		<nb-card>
		<nb-card-header style="text-align:center;">
		  <h5>Need Help in Process? Click Here
		  </h5>
		</nb-card-header>
		<nb-card-body style="text-align:center;">
		  <nb-tabset fullWidth>
		  <nb-tab tabTitle="Video" badgeStatus="danger">
			<img (click)="videoPopup()" class="videoimg"
			src="{{imageUrl}}/api/upload/profile_pic/PLAY.png" data-toggle="modal"
			style=" width: 140px;" data-width="440" data-height="360" data-target="#myModal" data-video-fullscreen="">
		  </nb-tab>
		  <nb-tab tabTitle="Manual" badgePosition="bottom right" badgeStatus="warning">
			<img (click)="manual()" style=" width: 110px; height:120px; " class="videoimg"
			src="{{imageUrl}}/api/upload/profile_pic/pdf.png">
		  </nb-tab>
	  
		  </nb-tabset>
	  
		</nb-card-body>
		<span style="font-size: 13px;">
		  कोणत्याही प्रश्नासाठी, कृपया आम्हाला <span style="font-weight: bold; color: red;">{{helpEmailId}}</span>वर ईमेल करा
		</span>
		</nb-card>
	  </div>

    <p-dialog [(visible)]="displayvideo1" [modal]="true" [responsive]="true" [style]="{width: 'auto', minWidth: 'auto'}">
      <nb-card  style="width: 350px;min-width: 200px;">
        <nb-card-body  id="cardbody1">
        <video id="video1" src="{{imageUrl}}/api/upload/videos/solverification.mp4" controls style="width: 300px;min-width: 200px;min-height: 200px;"></video>
        </nb-card-body>
      </nb-card>
      </p-dialog>
</div>



